module.exports = "<div [ngClass]=\"alertClass\" style=\"display: flex; text-align:center\">\n  <p>{{alertMessage}}</p>\n</div>\n"